import image from './resources/like.svg';
import { Box, ImageBox } from './styles';

type Props = {
    active: boolean;
}

export const Like = ({ active }: Props) => {
    return (
        <Box>
            <ImageBox src={image} $active={active} />
        </Box>
    );
}
